// @ts-nocheck
import { COUNTRIES_CONSTANT } from "./addressData";

export const configDefaultAddress = (configJson, countryCode, dataSave, isPickUpEnabled) => {
  let defaultCountryCode = COUNTRIES_CONSTANT.usa.code;

  let defaultAddress = {
    country: defaultCountryCode,
  };
  let defaultValidation = {
    country: true,
  };
  let dataFieldCustom = [],
    getDataInit = [],
    getSubList = [];

  if (Object.keys(configJson).length === 0) {
    return { defaultAddress, defaultValidation };
  } else {
    if (configJson.dataField.hasOwnProperty(countryCode)) {
      defaultAddress.country = countryCode;
      getDataInit = configJson.dataField[countryCode];
    } else {
      getDataInit = configJson.dataField[defaultCountryCode];
    }
  }

  if (getDataInit.length > 0) {
    getDataInit.forEach((item) => {
      item.controls.forEach((c) => {
        if (c.type === "comboBox") {
          if (c.hasOwnProperty("parent") && c.key === c.parent) {
            getSubList =
              c.data.find((item) => item.code === dataSave[c.parent])
                ?.subList || [];
          }

          dataFieldCustom.push({
            controls: [
              {
                ...c,
                data:
                  c.hasOwnProperty("parent") && c.key !== c.parent
                    ? getSubList
                    : c.data,
              },
            ],
          });
        } else {
          dataFieldCustom.push({
            controls: [c],
          });
        }
      });
    });
  }

  if (dataFieldCustom.length > 0) {
    dataFieldCustom.forEach((k) => {
      let targetField = k.controls[0];
      // check value exist to show after close dialog
      if (targetField.type === "textField") {
        if (targetField?.key?.toLowerCase()?.includes("code")) {
          const getCodeValue = (dataSave) => {
            for (const key in dataSave) {
              if (key.toLowerCase().includes("code")) {
                return dataSave[key];
              }
            }
            return "";
          };

          defaultAddress[targetField.key] = getCodeValue(dataSave);
        } else if (!!dataSave[targetField.key]) {
          defaultAddress[targetField.key] = dataSave[targetField.key];
        } else {
          defaultAddress[targetField.key] = "";
        }
      } else {
        if (targetField.data.length > 0) {
          if (
            targetField.data.find((h) => h.code === dataSave[targetField.key])
          ) {
            defaultAddress[targetField.key] = dataSave[targetField.key];
          } else {
            defaultAddress[targetField.key] = "";
          }
        }
      }

      if (isPickUpEnabled) {
        defaultAddress["isPickUp"] = dataSave["isPickUp"];
        defaultAddress["pickUpDepot"] = dataSave["pickUpDepot"];
      }

      // set validation
      if (
        !!targetField.validation.find((r) => r.type === "required") ||
        targetField.validation.indexOf("required") >= 0
      ) {
        defaultValidation[targetField.key] = true;
      }
    });
  }

  return { dataFieldCustom, defaultAddress, defaultValidation };
};

export const loadChildField = (configJson, valSelected, address, fieldName) => {
  const addressCustom = {
    ...address,
    [fieldName]: valSelected,
  };
  let { dataFieldCustom, defaultValidation, defaultAddress } =
    configDefaultAddress(configJson, address.country, addressCustom);

  return { dataFieldCustom, defaultValidation, defaultAddress };
};

export const sortCountriesByName = (countryList: ICountryProps[], defaultCode: string = 'usa') => {
  if (!Array.isArray(countryList) || countryList.length === 0) return [];
  const newList = [...countryList];

  newList.sort((a, b) => {
    const nameA = !!a.name && a.name.toUpperCase();
    const nameB = !!b.name && b.name.toUpperCase();
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  });

  let index = newList.findIndex(item => item.code === defaultCode);
  if (index < 0) index = newList.findIndex(item => item.code === 'usa');
  const defaultItem = newList.splice(index, 1);
  newList.unshift(...defaultItem);

  return newList;
};
